import { render, staticRenderFns } from "./CreateRoleStepNewUI.vue?vue&type=template&id=08a19b88"
import script from "./CreateRoleStepNewUI.vue?vue&type=script&lang=ts"
export * from "./CreateRoleStepNewUI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports